export default __webpack_public_path__ + "static/media/consulting.fb9064a9.jpg";